<script>
    import modals from '../state/modals';
    import surveys from '../state/surveys';
    import time from '../state/time';

    // Survey shorthand
    let survey = null;
    $: survey = $modals.survey_item;

    // Time has changed, update .active
    $: timeChanged($time.now);
    function timeChanged(currentTime)
    {
        // TODO: move this elsewhere

        // No survey selected!
        if (!survey) return;

        // Survey without timeframe, nothing to update
        if (!survey.sur_from && !survey.sur_to) {
            return;
        }

        // Get proper .active
        let isActive = (survey.sur_to >= currentTime ? 1 : 0);

        // Do not update, if not necessary (would trigger surveyChanged)
        if (isActive === survey.active) return;

        survey.active = isActive;
    }

    let selected = {};
    $: surveyChanged(survey);
    function surveyChanged(survey) {
        selected = {};
        status = null;

        if (!survey) return;

        for (let answer of survey.answers) {
            if (!survey.sur_multiple && !answer.selected) continue;

            selected[answer.sua_id] = !!answer.selected;

            if (!survey.sur_multiple) break;
        }
    }

    function changed(suaId, e) {
        let active = e.target.checked;
        status = null;

        if (!survey.sur_multiple) {
            selected = {};
        }

        selected[suaId] = active;
    }

    let status = null;

    let submitting = false;
    async function submit() {
        submitting = true;
        let resp = await surveys.setOptions(survey.sur_id, selected);
        submitting = false;

        status = resp && resp.status;
    }

    // Just close the modal
    function closeModal(e) {
        modals.toggleSurveyModal();
    }
</script>

<style>
    .modal-card-body {
        /* border-radius: 0 0 8px 8px; */
        padding: 0;
    }

    .question {
        font-size: 18px;
        padding: 10px;
        border-bottom: 1px solid #ececec;
    }

    .answers {
        padding: 4px 0;
    }

    .checky {
        position: relative;
    }

    .checky input {
        position: absolute;
        top: 0;
        left: 0;
        visibility: hidden;
    }

    .checky label {
        cursor: pointer;
        display: inline-flex;
        margin: 0;
        padding: 8px 10px;
        font-size: 14px;
        vertical-align: bottom;
        align-items: center;
    }

    .checky label::before {
        content: '';
        height: 21px;
        width: 21px;
        min-width: 21px;
        line-height: 21px;
        margin-right: 10px;
        border: 1px solid #BBC1E1;
        font-family: "Font Awesome 5 Pro";
        font-weight: 900;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-style: normal;
        font-variant: normal;
        text-rendering: auto;
        text-align: center;
        color: white;
    }

    .checky label:hover::before {
        border-color: dodgerblue;
    }

    .checky input[type="checkbox"] + label::before {
        content: "\f00c";
        border-radius: 7px;
        font-size: 10px;
    }

    .checky input[type="radio"] + label::before {
        content: "\f111";
        border-radius: 50%;
        font-size: 8px;
    }

    .checky input:not(:checked) + label::before {
        font-size: 0;
    }

    .checky input:checked + label::before {
        background: dodgerblue;
        border-color: dodgerblue;
    }
</style>

{#if $modals.survey_opened}
    <div class="modal is-active">
        <div class="modal-background" on:click={closeModal}></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <div class="modal-card-title">Anketa</div>
                <button class="delete" aria-label="Zavřít" on:click={closeModal}></button>
            </header>
            <section class="modal-card-body">
                {#if !survey.sur_active && !survey.active}
                    <article class="message is-info">
                        <div class="message-body">
                            Anketa byla uzavřena!<br>
                            Ohledně výsledků vás budeme informovat.
                        </div>
                    </article>
                {:else}
                    <div class="question">{survey.sur_question}</div>
                    <div class="answers">
                        {#each survey.answers as answer}
                            <div class="checky">
                                <input
                                    type={survey.sur_multiple ? 'checkbox' : 'radio'}
                                    name="answer"
                                    id={`answer-${answer.sua_id}`}
                                    checked={selected[answer.sua_id]}
                                    on:change={(e) => changed(answer.sua_id, e)} />
                                <label for={`answer-${answer.sua_id}`}>{answer.sua_answer}</label>
                            </div>
                        {/each}

                        <!-- <pre>{JSON.stringify(selected, null, 4)}</pre> -->
                    </div>

                    {#if status === true}
                        <article class="message is-success">
                            <div class="message-body">
                                Odpovědi na anketu byly úšpěšně uloženy!<br>
                                Dokud bude anketa otevřena, tak je můžete změnit!
                            </div>
                        </article>
                    {:else if status === false}
                        <article class="message is-danger">
                            <div class="message-body">
                                Odpovědi se nepodařilo uložit.<br>
                                Zkuste obnovit stránku a zkusit to znovu.
                            </div>
                        </article>
                    {/if}
                {/if}
            </section>
            <footer class="modal-card-foot">
                {#if survey.sur_active || survey.active}
                    <button class="button is-success" on:click={submit} disabled={submitting}>Uložit</button>
                    <!-- <button class="button">Cancel</button> -->
                {/if}
            </footer>
        </div>
    </div>
{/if}